import React, { useState } from "react";

import { Button, Modal } from "react-bootstrap";
import { formatDate } from "../../utils/formateDate";
import Radio from "@mui/material/Radio";
import moment from "moment";
import { ApiHook } from "../../hooks/apiHook";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const EventListView = ({ show, handleClose, eventsList, eventId,eventStatus,leadId,stepId }) => {

  const addEventstatusMutation = ApiHook.AddeventStatusChange();
    const queryClient = useQueryClient();

  const statusColors = {
    1: "Completed",
    2: "Canceled",
    0: "Pending",
  };

  const handleEventUpdate = (updateValue, eventId) => {
    addEventstatusMutation.mutate(
      { eventFormData: { eventId: eventId, eventStatus: updateValue ,leadId:leadId,stepId:stepId} },
      {
        onSuccess: (res) => {
          if (res.status) {
            toast.success("Event added successfully");
            queryClient.invalidateQueries({ queryKey: ["crm-list"] });
            handleClose();
          } else {
            toast.error("Something went wrong");

            handleClose();
          }
        },
      }
    );
  };

  return (
    <div className="container mt-4">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Event List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {eventsList?.crmEvents?.length ==0 && (
            <>No Events Found</>
          )}

         
            {eventsList?.crmEvents?.map((event) => (
            <div className="max-w-md mx-auto mt-10 p-6  shadow-lg rounded-lg p-4">
              <div
                key={event.id}
                className="flex justify-between items-center border-b py-3"
                style={{ display: "flex" }}
              >
                <div
                  className="event_date_data"
                  style={{
                    background: "rgb(246 238 255)",
                    padding: "20px",
                    border: "1px solid rgb(183 148 217)",
                    maxHeight: "100px",
                    height: "80px",
                  }}
                >
                  <div>{moment(event.start).format("MMM")}</div>
                  <div>{moment(event.start).format("DD")}</div>
                </div>

                <span
                  className="flex-1 text-gray-700 px-3"
                  style={{ fontWeight: "bold" }}
                >
                  <b>{event.eventDescription}</b>
                  <p style={{ fontSize: "12px", color: "grey" }}>
                    <i class="far fa-calendar-alt" aria-hidden="true"></i>{" "}
                    {moment(event.start).format("MMM DD, YYYY - hh:mm A")}
                  </p>
                  <p style={{ fontSize: "12px", color: "grey" }}>
                    <i class="fa fa-check" aria-hidden="true"></i>{" "}
                    {statusColors[event.eventStatus]}
                  </p>
                  <p style={{ fontSize: "12px", color: "grey" }}>
                    <i class="fas fa-funnel-dollar"></i>{" "}
                    {event['salesFunnelStage.name']}
                  </p>

                 
                </span>
              </div>
      
              {!event.eventStatus &&  eventStatus== 2 && eventId ? (
                <div
                  className="status_chage_button"
                  style={{ textAlign: "center" }}
                >
                  <div class="btn-group" role="group">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      onClick={() => handleEventUpdate(2, event.id)}
                    >
                      Mark as Canceled
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      onClick={() => handleEventUpdate(1, event.id)}
                      style={{ background: "#954cea" }}
                    >
                      Mark as Completed
                    </button>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>))}
          
          
         {/* {eventsList?.crmEvents?.length === 0 ? (
  <>No Events Found</>
) : (
  eventsList?.crmEvents?.map((event) => (
    <div key={event.id} className="max-w-md mx-auto mt-10 p-6 shadow-lg rounded-lg">
      <div className="flex justify-between items-center border-b py-3">
        <div
          className="event_date_data"
          style={{
            background: "rgb(246 238 255)",
            padding: "20px",
            border: "1px solid rgb(183 148 217)",
            maxHeight: "100px",
            height: "80px",
          }}
        >
          <div>{moment(event.start).format("MMM")}</div>
          <div>{moment(event.start).format("DD")}</div>
        </div>

        <span className="flex-1 text-gray-700 px-3" style={{ fontWeight: "bold" }}>
          <b>{event.eventDescription}</b>
          <p style={{ fontSize: "12px", color: "grey" }}>
            <i className="far fa-calendar-alt" aria-hidden="true"></i>{" "}
            {moment(event.start).format("MMM DD, YYYY - hh:mm A")}
          </p>
          <p style={{ fontSize: "12px", color: "grey" }}>
            <i className="fa fa-check" aria-hidden="true"></i>{" "}
            {statusColors[event.eventStatus]}
          </p>
          <p style={{ fontSize: "12px", color: "grey" }}>
            <i className="fas fa-funnel-dollar"></i>{" "}
            {event["salesFunnelStage.name"]}
          </p>
        </span>
      </div>

   
      {event.eventStatus ===0 && eventId && (
        <div className="status_chage_button" style={{ textAlign: "center" }}>
          <div className="btn-group" role="group">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => handleEventUpdate(2, event.id)}
            >
              Mark as Canceled
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => handleEventUpdate(1, event.id)}
              style={{ background: "#954cea" }}
            >
              Mark as Completed
            </button>
          </div>
        </div>
      )}
    </div>
  ))
)} */}

        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EventListView;
